import { useGlobalData } from "@/app/global_data"
import { Entity } from "@/app/types"
import { ComparisonNew } from "@/app/types/comparison_new"
import { ItemGroup, SelectorProps } from "@/components/selector/selector"

function createComparisonItemGroup(
  isFund: boolean,
  comparison: ComparisonNew,
  entity: Entity,
  chartTop10MetricText: string,
  shouldDisplayDifferentText: boolean
): ItemGroup {
  const groupKey = isFund ? "fund_choices" : "firm_choices"
  const groupText =
    isFund ? "Fund Comparison Choices" : "Firm Comparison Choices"

  const items = comparison.getGroups(isFund).map((g) => {
    const top10ComparisonText =
      shouldDisplayDifferentText ?
        `Top10 ${isFund ? "Funds" : "Firms"} by ${chartTop10MetricText}`
      : comparison.getGroupNameByKey(g.key, isFund)

    const allComparisonText =
      isFund ?
        `${entity.getFund().category} Category`
      : comparison.getGroupNameByKey(g.key, isFund)

    return {
      key: g.key,
      text:
        g.key === ComparisonNew.TOP10 ? top10ComparisonText
        : g.key === ComparisonNew.ALL ? allComparisonText
        : g.key === ComparisonNew.PEERS ? g.name
        : comparison.getGroupNameByKey(g.key, isFund),
    }
  })

  return { key: groupKey, text: groupText, items }
}

export function getComparisonSelectorOptions(
  entity: Entity,
  comparison: ComparisonNew,
  onSelect: (key: string, groupKey?: string) => void,
  shouldDisplayDifferentText: boolean = true
) {
  const { chart } = useGlobalData().get()

  const comparisonItemGroup = createComparisonItemGroup(
    entity.isFund(),
    comparison,
    entity,
    chart.top10Metric.text,
    shouldDisplayDifferentText
  )

  const comparisonSelector: SelectorProps = {
    options: [comparisonItemGroup],
    selectedKey: comparison.getGroup(),
    onSelect,
  }

  return { comparisonSelector }
}
